<template>
  <div class="container">
    <div class="login_container">
      <img src="@/assets/Image/LoginLogo.png" alt="logo" />

      <template v-if="step === 'login'">
        <h2>تسجيل الدخول</h2>
        <form @submit.prevent="login">
          <div class="email_container">
            <f-input
              label="البريد الالكتروني او رقم الهاتف"
              type="text"
              Placeholder="ادخل البريد الالكتروني او رقم الهاتف هنا"
              v-model="email"
              :inputClass="wrongEmail ? 'wrong' : '' || emptyEmail ? 'wrong' : ''"
            />
            <span v-if="wrongEmail"
              >البريد الإلكتروني أو رقم الهاتف غير صحيح</span
            >
            <span v-if="emptyEmail"
              >يجب ملئ البريد الالكتروني او رقم الهاتف</span
            >
          </div>
          <div class="pass_container">
            <f-password
              label="كلمة المرور"
              v-model="password"
              Placeholder="ادخل كلمة المرور هنا"
              :inputClass="wrongPass ? 'wrong' : '' || emptyPass ? 'wrong' : ''"
            />
            <span v-if="wrongPass">كلمة المرور غير صحيحة</span>
            <span v-if="emptyPass">يجب ادخال كلمة المرور</span>
          </div>
          <div class="footer_section" v-if="!loading">
            <f-button btnType="submit">تسجيل الدخول</f-button>
          </div>
          <div class="footer_section" v-else>
            <div class="lds-ellipsis">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </form>
      </template>

      <template v-else>
        <div class="otp_header">
          <h2>التحقق برمز SMS</h2>
          <p v-if="otpMessage">{{ otpMessage }}</p>
          <p v-else>تم إرسال رمز التحقق إلى رقم هاتفك المسجل.</p>
          <p class="otp_hint">الرمز صالح لمدة 5 دقائق</p>
        </div>
        <form class="otp_form" @submit.prevent="verifyOtp">
          <div class="otp_inputs_wrapper">
            <OTPComponent
              ref="otpComponent"
              @update-otp="otpNumber = $event"
            />
          </div>
          <span v-if="otpError" class="otp_error">{{ otpError }}</span>
          <div class="footer_section otp_actions" v-if="!loading">
            <f-button
              btnType="submit"
              type="primary"
              :disabled="otpNumber.length !== 6"
            >
              تحقق
            </f-button>
            <button
              type="button"
              class="resend_btn"
              :disabled="resendCooldown > 0 || loading"
              @click="resendOtp"
            >
              {{
                resendCooldown > 0
                  ? `إعادة الإرسال (${resendCooldown}s)`
                  : "إعادة إرسال الرمز"
              }}
            </button>
            <button type="button" class="back_btn" @click="backToLogin">
              العودة لتسجيل الدخول
            </button>
          </div>
          <div class="footer_section" v-else>
            <div class="lds-ellipsis">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </form>
      </template>
    </div>
    <div class="image_container">
      <span></span>
      <img src="@/assets/Image/truck.png" alt="" />
    </div>
  </div>
</template>

<script>
import http from "@/Services/Axios";
import { useAuthStore } from "@/Stores/AuthStore";
import { setSecureItem } from "@/Utils/SecureStorage";
import { toast } from "vue3-toastify";
import OTPComponent from "@/components/LoginComponents/OTPComponent.vue";
import {
  buildOtpArabicMessage,
  getAuthPayload,
  getAuthRoles,
  getAuthToken,
  isAuthenticatedResponse,
  isOtpRequired,
} from "@/Utils/AuthResponse";

const OTP_SESSION_KEY = "qr_login_otp_session";

export default {
  components: {
    OTPComponent,
  },
  data() {
    return {
      step: "login",
      email: "",
      password: "",
      otpNumber: "",
      otpMessage: "",
      otpError: "",
      resendCooldown: 0,
      resendTimer: null,
      wrongEmail: false,
      emptyEmail: false,
      wrongPass: false,
      emptyPass: false,
      AuthStore: useAuthStore(),
      loading: false,
    };
  },
  mounted() {
    this.restoreOtpSession();
  },
  beforeUnmount() {
    this.clearResendTimer();
  },
  methods: {
    validateEmailOrPhone(input) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const phonePattern = /^[0-9]{10,15}$/;
      return emailPattern.test(input) || phonePattern.test(input);
    },
    clearResendTimer() {
      if (this.resendTimer) {
        clearInterval(this.resendTimer);
        this.resendTimer = null;
      }
    },
    startResendCooldown(seconds = 60) {
      this.clearResendTimer();
      this.resendCooldown = seconds;
      this.resendTimer = setInterval(() => {
        if (this.resendCooldown <= 1) {
          this.resendCooldown = 0;
          this.clearResendTimer();
          return;
        }
        this.resendCooldown -= 1;
      }, 1000);
    },
    saveOtpSession() {
      sessionStorage.setItem(
        OTP_SESSION_KEY,
        JSON.stringify({
          email: this.email,
          otpMessage: this.otpMessage,
        })
      );
    },
    clearOtpSession() {
      sessionStorage.removeItem(OTP_SESSION_KEY);
    },
    restoreOtpSession() {
      const saved = sessionStorage.getItem(OTP_SESSION_KEY);
      if (!saved) return;

      try {
        const { email, otpMessage } = JSON.parse(saved);
        if (!email) return;

        this.email = email;
        this.otpMessage = otpMessage || "";
        this.step = "otp";
        this.startResendCooldown(0);
      } catch {
        this.clearOtpSession();
      }
    },
    backToLogin() {
      this.step = "login";
      this.otpNumber = "";
      this.otpError = "";
      this.otpMessage = "";
      this.clearOtpSession();
      this.clearResendTimer();
      this.resendCooldown = 0;
    },
    showOtpStep(data) {
      this.step = "otp";
      this.otpNumber = "";
      this.otpError = "";
      this.otpMessage = buildOtpArabicMessage(data, this.email);
      this.saveOtpSession();
      this.startResendCooldown(60);

      this.$nextTick(() => {
        this.$refs.otpComponent?.clear?.();
      });
    },
    async completeLogin(data) {
      const payload = getAuthPayload(data);
      const token = getAuthToken(data);
      const roles = getAuthRoles(data);
      const role = roles[0];

      if (!token) {
        toast.error("لم يتم استلام رمز الدخول. يرجى المحاولة مرة أخرى");
        return;
      }

      this.AuthStore.setLoginResponse(payload);
      setSecureItem("qr-token", token);
      if (role) {
        setSecureItem("role", role);
      }

      this.clearOtpSession();
      this.navigateByRole(role);
    },
    navigateByRole(role) {
      if (role === "QrReader") {
        this.$router.push("/reader-home");
        return;
      }

      toast.info("سوف يتم تحويلك الى نظام التكييل");
      setTimeout(() => {
        window.location.href = "https://takeeldep.gov.iq";
      }, 3000);
    },
    handleSignInError(error) {
      const data = error?.response?.data;
      const status = error?.response?.status;

      if (data === "User not found.") {
        toast.error("البريد الالكتروني الذي ادخلته غير مسجل");
        this.wrongEmail = true;
        return;
      }
      if (data === "Invalid email or password.") {
        toast.error("كلمة المرور او البريد الالكتروني الذي ادخلتهم خاطئة");
        this.wrongPass = true;
        return;
      }
      if (data === "Account is not confirmed.") {
        toast.error("هذا الحساب غير مفعل, يرجى التفعيل قبل التسجيل");
        this.wrongPass = true;
        return;
      }
      if (
        data ===
        "No phone number is registered for this account to receive the OTP."
      ) {
        toast.error("لا يوجد رقم هاتف مسجل لهذا الحساب لاستلام رمز التحقق");
        return;
      }
      if (data === "Failed to send the OTP. Please try again.") {
        toast.error("فشل إرسال رمز التحقق. يرجى المحاولة مرة أخرى");
        return;
      }
      if (status === 403) {
        toast.error("تم قفل الحساب أو لا يسمح بتسجيل الدخول");
        return;
      }
      if (Array.isArray(data)) {
        toast.error(data[0]?.errorMessage || "يرجى التحقق من البيانات المدخلة");
        return;
      }
      toast.error("حدث خطأ أثناء تسجيل الدخول. يرجى المحاولة لاحقاً");
    },
    handleVerifyOtpError(error) {
      const data = error?.response?.data;
      const status = error?.response?.status;

      if (data === "The OTP is invalid.") {
        this.otpError = "رمز التحقق غير صحيح";
        toast.error(this.otpError);
        return;
      }
      if (data === "The OTP has expired. Please sign in again.") {
        toast.error("انتهت صلاحية رمز التحقق. يرجى تسجيل الدخول مرة أخرى");
        this.backToLogin();
        return;
      }
      if (data === "User not found.") {
        toast.error("المستخدم غير موجود");
        this.backToLogin();
        return;
      }
      if (status === 403) {
        toast.error("لا يمكن التحقق من هذا الحساب");
        this.backToLogin();
        return;
      }
      if (Array.isArray(data)) {
        this.otpError = data[0]?.errorMessage || "يرجى إدخال رمز التحقق";
        toast.error(this.otpError);
        return;
      }
      toast.error("حدث خطأ أثناء التحقق. يرجى المحاولة لاحقاً");
    },
    async login() {
      this.loading = true;
      this.otpError = "";
      this.emptyEmail = false;
      this.emptyPass = false;
      this.wrongEmail = false;
      this.wrongPass = false;

      try {
        if (this.email.trim() === "" || this.password.trim() === "") {
          if (this.email.trim() === "") {
            this.emptyEmail = true;
            toast.error("يجب ملئ البريد الالكتروني او رقم الهاتف");
          }
          if (this.password.trim() === "") {
            this.emptyPass = true;
            toast.error("يجب ادخال كلمة المرور");
          }
          return;
        }

        if (!this.validateEmailOrPhone(this.email)) {
          this.wrongEmail = true;
          toast.error("البريد الإلكتروني أو رقم الهاتف غير صحيح");
          return;
        }

        const response = await http.post("/authorizations/sign-in", {
          email: this.email,
          password: this.password,
        });

        if (isOtpRequired(response.data)) {
          this.showOtpStep(response.data);
          return;
        }

        if (!isAuthenticatedResponse(response.data)) {
          toast.error("استجابة غير متوقعة من الخادم. يرجى المحاولة لاحقاً");
          return;
        }

        await this.completeLogin(response.data);
      } catch (error) {
        this.handleSignInError(error);
        console.error("Login failed:", error?.response?.data);
      } finally {
        this.loading = false;
      }
    },
    async verifyOtp() {
      if (this.otpNumber.length !== 6) {
        this.otpError = "يرجى إدخال رمز التحقق المكون من 6 أرقام";
        return;
      }

      this.loading = true;
      this.otpError = "";

      try {
        const response = await http.post("/authorizations/verify-login-otp", {
          email: this.email,
          otp: this.otpNumber,
        });

        await this.completeLogin(response.data);
      } catch (error) {
        this.handleVerifyOtpError(error);
        console.error("OTP verification failed:", error?.response?.data);
      } finally {
        this.loading = false;
      }
    },
    async resendOtp() {
      if (this.resendCooldown > 0 || this.loading) return;

      if (!this.password) {
        toast.info("يرجى العودة لتسجيل الدخول لإعادة إرسال الرمز");
        return;
      }

      this.loading = true;
      this.otpError = "";

      try {
        const response = await http.post("/authorizations/sign-in", {
          email: this.email,
          password: this.password,
        });

        if (isOtpRequired(response.data)) {
          this.otpNumber = "";
          this.otpMessage = buildOtpArabicMessage(response.data, this.email);
          this.saveOtpSession();
          toast.success("تم إرسال رمز تحقق جديد");
          this.startResendCooldown(60);
          this.$nextTick(() => {
            this.$refs.otpComponent?.clear?.();
          });
          return;
        }

        if (!isAuthenticatedResponse(response.data)) {
          toast.error("استجابة غير متوقعة من الخادم. يرجى المحاولة لاحقاً");
          return;
        }

        await this.completeLogin(response.data);
      } catch (error) {
        this.handleSignInError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.container {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100vh;
}

.container .login_container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  width: 40%;
  height: 100%;
}

.login_container img {
  width: 400px;
}

.login_container h2 {
  font-size: 24px;
  font-weight: 500;
  line-height: 40px;
}

.login_container form {
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
}

.login_container form .email_container {
  width: 100%;
}

.email_container span,
.pass_container span,
.otp_error {
  color: red;
  font-size: 11px;
}

.login_container form .pass_container {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.otp_header {
  text-align: center;
  width: 100%;
  max-width: 420px;
}

.otp_header p {
  color: var(--dark-gray);
  font-size: 14px;
  line-height: 1.7;
  margin: 8px 0 0;
  direction: rtl;
}

.otp_form {
  width: 100%;
  max-width: 420px;
}

.otp_inputs_wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
}

.otp_hint {
  font-size: 12px !important;
  color: #6b7280 !important;
}

.otp_actions {
  margin-top: 12px;
}

.resend_btn,
.back_btn {
  background: none;
  border: none;
  cursor: pointer;
  font-family: var(--font-family);
  font-size: 14px;
  padding: 4px 0;
}

.resend_btn {
  color: var(--primary-color);
}

.resend_btn:disabled {
  color: #9ca3af;
  cursor: not-allowed;
}

.back_btn {
  color: #374151;
}

.footer_section {
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 7px;
  margin-top: 8px;
}

.container .image_container {
  width: 60%;
  height: 100%;
  overflow: hidden;
  position: relative;
}

.image_container span {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    179.6deg,
    rgba(255, 255, 255, 0) 8.08%,
    rgba(219, 222, 243, 0.06) 32.1%,
    rgba(210, 217, 236, 0.0878021) 38.43%,
    rgba(76, 127, 114, 0.515479) 58.77%,
    rgba(0, 76, 44, 0.76) 103.51%
  );
}

.image_container img {
  object-fit: cover;
  width: 100%;
  height: 100%;
  object-position: right;
}

.lds-ellipsis,
.lds-ellipsis div {
  box-sizing: border-box;
}
.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 20px;
  margin: 0 auto;
}
.lds-ellipsis div {
  position: absolute;
  top: 5px;
  width: 13.33333px;
  height: 13.33333px;
  border-radius: 50%;
  background: var(--primary-color);
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}

@media (max-width: 768px) {
  .image_container {
    display: none;
  }
  .login_container {
    width: 100% !important;
  }
}
</style>
